import { render, staticRenderFns } from "./BYOThemeElementSelector.vue?vue&type=template&id=6dfba18b&scoped=true&"
import script from "./BYOThemeElementSelector.js?vue&type=script&lang=js&"
export * from "./BYOThemeElementSelector.js?vue&type=script&lang=js&"
import style0 from "./BYOThemeElementSelector.scss?vue&type=style&index=0&id=6dfba18b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfba18b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
